import axios from "axios";
import { getAuthHeader } from "./auth";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function fetchUserStats() {
  try {
    const headers = await getAuthHeader();
    const response = await axios.get(`${API_BASE_URL}/api/users/me/`, { headers });
    const userData = response.data || {};

    return {
      followingCount: Number(userData.following_count || 0),
      followersCount: Number(userData.followers_count || 0),
      postsCount: Number(userData.posts_count || 0),
    };
  } catch (error) {
    console.error("Error fetching user stats:", error.response?.data || error.message);
    return {
      followingCount: 0,
      followersCount: 0,
      postsCount: 0,
    };
  }
}

export async function fetchVolunteerPreferences() {
  try {
    const headers = await getAuthHeader();
    const response = await axios.get(`${API_BASE_URL}/api/users/me/volunteer-preferences/`, {
      headers,
    });
    return response.data;
  } catch (error) {
    if (error.response?.status !== 404 && error.response?.status !== 500) {
      console.error(
        "Error fetching volunteer preferences:",
        error.response?.data || error.message
      );
    }

    return {
      is_interested: false,
      volunteer_radius_miles: 25,
      volunteer_city: "",
      volunteer_state: "",
      use_home_location: true,
      preferred_event_types: [],
    };
  }
}

export async function uploadProfileImageBase64(base64Data, contentType = "image/jpeg") {
  const headers = await getAuthHeader();
  const response = await axios.post(
    `${API_BASE_URL}/api/users/me/profile-image/`,
    {
      image_data: base64Data,
      content_type: contentType,
    },
    { headers }
  );
  return response.data;
}

export async function getOrgVerificationStatus() {
  const headers = await getAuthHeader();
  const response = await axios.get(`${API_BASE_URL}/api/org-verification/status/`, {
    headers,
  });
  return response.data;
}
